import { type IResponseConversation } from 'entities/Conversation/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export const canAddConversationToList = (item: IResponseConversation, entities: IEntitiesStore) => {
  if (!entities.inboxesStore.currentInbox) return false
  if (entities.inboxesStore.currentInbox?.type === 'unified-inbox') return true

  return item.inbox_id === entities.inboxesStore.currentInbox.id
}
